export const FIRST_OPEN_WELCOME_KEY = 'xtg_welcome_seen_v1';
